// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {UserIconEl} from 'common/widgets/user-icon';
import {ModalEl} from 'common/components/modal';
import {ButtonEl} from 'common/components/button';
import {IconSizeType} from 'common/constants';
import {ButtonTheme} from 'common/components/button/constants';

import type {AvatarUpload} from './index';

export function template(this: AvatarUpload) {
  return (
    <div sel='.avatar-upload-container'>
      <div sel='.avatar'>
        <UserIconEl
          attrs={{
            elref: `avatarUserIcon`,
            id: this.params.id,
            name: this.params.name,
            size: IconSizeType.XL,
            'img-src': this.helpers.getAvatarUrl(),
          }}
        />
        <input
          attrs={{
            elref: `fileInput`,
            type: `file`,
            style: `display: none;`,
            accept: `image/png, image/jpeg`,
          }}
          hook={{
            insert: this.helpers.fileInputInserted,
          }}
          on={{
            change: () => this.helpers.handleFileInputChange(),
          }}
        />
        <ButtonEl
          sel='.upload-button'
          attrs={{
            elref: `uploadButton`,
            theme: ButtonTheme.Primary,
            icon: `edit`,
          }}
          on={{
            click: this.helpers.handleUploadClick,
          }}
        />
      </div>

      {this.params.hideName ? null : <div sel='.name'>{this.params.name}</div>}
      <ModalEl
        attrs={{
          closeable: !this.state.isEditingImage,
          open: this.state.isUploadModalOpen,
        }}
        on={{
          change: (ev: CustomEvent) => this.helpers.handleModalChange(ev),
        }}
      >
        {this.state.isUploadModalOpen && (
          <div sel='.upload-avatar-modal'>
            <div sel='.title'>Update Profile Photo</div>
            <div sel='.avatar-editor'>
              <img
                sel='#avatar-image'
                attrs={{
                  src: this.state.sourceImage || ``,
                }}
                on={{
                  load: (ev: Event) => this.helpers.avatarImgElementLoad(ev.target as HTMLImageElement),
                }}
              />
            </div>
            <div sel='.actions'>
              <ButtonEl
                attrs={{
                  elref: `saveAvatarButton`,
                  theme: ButtonTheme.Primary,
                }}
                on={{
                  click: this.helpers.handleImageCropped,
                }}
              >
                Save
              </ButtonEl>
            </div>
          </div>
        )}
      </ModalEl>
    </div>
  );
}
